import { useLocation } from 'react-router-dom';

const PAGE_SUGGESTIONS: Record<string, string[]> = {
  '/approvals': ['What needs my approval?', 'Show pending invoices', 'Show pending postings'],
  '/records': ['Find an invoice', 'Find a vendor', 'Any discount deadlines soon?'],
  '/': ['What needs my attention?', 'Show pending invoices', 'Check QB connection'],
  '/reviews': ['Show pending invoices', 'Show pending postings', 'Any discount deadlines soon?'],
  '/vendors': ['Find a vendor', 'Show inactive vendors'],
  '/approval-chains': ['List approval chains'],
};

const DEFAULT_SUGGESTIONS = [
  'Show pending invoices',
  'What needs my approval?',
  'Check my subscription usage',
];

interface SuggestionChipsProps {
  onSelect: (suggestion: string) => void;
}

export const SuggestionChips = ({ onSelect }: SuggestionChipsProps) => {
  const { pathname } = useLocation();
  const suggestions = PAGE_SUGGESTIONS[pathname] ?? DEFAULT_SUGGESTIONS;

  return (
    <div className="px-3 py-2 flex flex-wrap gap-2">
      {suggestions.map((s) => (
        <button
          key={s}
          onClick={() => onSelect(s)}
          className="px-3 py-1.5 rounded-full text-xs font-medium border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-[rgb(var(--color-primary-rgb))] hover:text-[rgb(var(--color-primary-rgb))] transition-colors"
        >
          {s}
        </button>
      ))}
    </div>
  );
};
